import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import { sectionSpacing } from "./section-spacing";
import { headingFontFamily } from "../heading-font";
import * as React from "react";

export interface FeatureHighlightCard {
	eyebrow: string;
	title: string;
	description: string;
	icon: React.ReactElement;
}

export interface FeatureHighlightsContent {
	heading: string;
	features: FeatureHighlightCard[];
}

export function FeatureHighlights({
	content: data,
}: {
	content: FeatureHighlightsContent;
}) {
	return (
		<Box
			sx={{
				bgcolor: "var(--mui-palette-background-level1)",
				py: sectionSpacing,
			}}>
			<Container maxWidth="xl">
				<Stack spacing={8}>
					<Stack
						maxWidth="700px"
						spacing={2}
						sx={{ mx: "auto" }}>
						<Typography
							sx={{ textAlign: "center", fontFamily: headingFontFamily }}
							variant="h3">
							{data.heading}
						</Typography>
					</Stack>
					<Grid
						container
						spacing={{ xs: 2, md: 3 }}>
						{data.features.map((feature) => (
							<Grid
								key={feature.title}
								size={{ xs: 12, sm: 6, md: 4 }}>
								<Card
									elevation={2}
									sx={{
										borderRadius: 4,
										height: "100%",
									}}>
									<CardContent sx={{ p: 3 }}>
										<Stack spacing={2}>
											<div>
												<Chip
													color="secondary"
													icon={feature.icon}
													label={feature.eyebrow}
													size="small"
													variant="soft"
												/>
											</div>
											<Typography
												sx={{ fontFamily: headingFontFamily }}
												variant="h5">
												{feature.title}
											</Typography>
											<Typography
												color="text.secondary"
												variant="body2">
												{feature.description}
											</Typography>
										</Stack>
									</CardContent>
								</Card>
							</Grid>
						))}
					</Grid>
				</Stack>
			</Container>
		</Box>
	);
}
